import { ListStickyNotesQueryVariables } from '@akin-home/amplify';
import { useCreateStickyNote } from './useCreateStickyNote';
import { useDeleteStickyNote } from './useDeleteStickyNote';
import { useListStickyNotes } from './useListStickyNotes';
import { useUpdateStickyNote } from './useUpdateStickyNote';

/** Sticky notes hook */
const useStickyNotes = (params?: ListStickyNotesQueryVariables) => {
  const results = useListStickyNotes({ params });

  const create = useCreateStickyNote();
  const update = useUpdateStickyNote();
  const remove = useDeleteStickyNote();

  return {
    ...results,
    create,
    update,
    remove,
  };
};

/** Get the sticky notes for the given habitat */
const useHabitatStickyNotes = (habitatID: string) =>
  useStickyNotes({ filter: { habitatID: { eq: habitatID } } });

export { useHabitatStickyNotes };
